import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Breadcrumb } from "react-bootstrap";

const DynamicBreadcrumb = ({ pathArray = null, classesName = null }) => {
  const location = useLocation();
  // const pathname = location.pathname;
  // console.log(pathArray);

  // Split the pathname into parts
  // const pathnames = pathname.split('/').filter((x) => x);

  return (
    <Breadcrumb className={`my-5 ${classesName ? classesName : ''}`} >
      <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/admin/" }}>
        Admin
      </Breadcrumb.Item>

      {pathArray && pathArray.map((value, index) => {
        const to = value.url ?? null;
        const title = value.name ?? "";
        const key = `${to ?? "active"}-${index}`; // ✅ unique always

        return to === null ? (
          <Breadcrumb.Item active key={key}>
            {title.charAt(0).toUpperCase() + title.slice(1)}
          </Breadcrumb.Item>
        ) : (
          <Breadcrumb.Item linkAs={Link} linkProps={{ to }} key={key}>
            {title.charAt(0).toUpperCase() + title.slice(1)}
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
};

export default DynamicBreadcrumb;
